/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var models;
    (function (models) {
        var ConstantConfigurationModel = /** @class */ (function () {
            function ConstantConfigurationModel(constantService, systemLevelService, deleteService, id, growl) {
                var _this = this;
                this.constantService = constantService;
                this.systemLevelService = systemLevelService;
                this.deleteService = deleteService;
                this.id = id;
                this.growl = growl;
                this.dropDownContext = new models.EnumDropDownContext();
                this.dropDownContext.includeSpecifiedOptionsOnly = [
                    0 /* String */,
                    1 /* Integer */,
                    2 /* Decimal */,
                    6 /* Boolean */
                ];
                if (id) {
                    constantService.getAllConstantsForProcessConfiguration(id).then(function (c) {
                        _this.constants = c;
                    });
                }
                else {
                    systemLevelService.getSystemLevelConstants().then(function (systemLevel) {
                        _this.systemLevel = systemLevel;
                        _this.constants = systemLevel.myConstants;
                    });
                }
            }
            ConstantConfigurationModel.prototype.addConstant = function () {
                var newConstant = this.constantService.createConstant();
                if (this.id) {
                    newConstant.processConfiguration_id = this.id;
                }
                else {
                    newConstant.systemLevel_id = this.systemLevel.id;
                }
                this.constants.push(newConstant);
            };
            ConstantConfigurationModel.prototype.removeConstant = function (constant) {
                var _this = this;
                this.deleteService.deleteWithModalConfirmIfNecessary("ConstantValue", constant.id, "Constant", function () {
                    _this.constants.remove(constant);
                });
            };
            ConstantConfigurationModel.prototype.cancel = function () {
                this.constantService.rejectChanges();
            };
            ConstantConfigurationModel.prototype.save = function () {
                this.constantService.saveAllChanges();
            };
            return ConstantConfigurationModel;
        }());
        models.ConstantConfigurationModel = ConstantConfigurationModel;
    })(models = warsApp.models || (warsApp.models = {}));
})(warsApp || (warsApp = {}));
